import View from './SideBar';
import enhancer from './SideBar.enhancer';

const SideBar = enhancer(View);

export default SideBar;
